import * as React from "react";
import Spinner from '../../../common/components/spinner/spinner';
import Translate from '../../../common/functions/translate';
import UserService from '../../../services/userService';
import AuthService from '../../../services/authService';
import { UserPrescriptionGridModel } from '../../../models/user/userPrescriptionGridModel';
import { UserPrescriptionModel } from '../../../models/user/userPrescriptionModel';
import UserPrescriptionList from './userPrescriptionList';
import UserPrescriptionAddEditDialog from './userPrescriptionAddEditDialog';
import ConfirmDialog from '../../../common/components/confirmDialog/confirmDialog';
import PrescriptionMedicineListDialog from './prescriptionMedicineListDialog';
import PrescriptionDiseaseListDialog from './prescriptionDiseaseListDialog';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPills, faUserMd, faNotesMedical, faCheckCircle, faFileAlt, faUtensils, faStethoscope,
  faExclamationTriangle, faHospital, faChevronUp, faChevronDown
} from '@fortawesome/free-solid-svg-icons';
import { connect } from 'react-redux';
import Fab from '@material-ui/core/Fab';
import Growl from '../../../common/components/alertMessage/growl';
import AddIcon from '@material-ui/icons/Add';
import ExpandingList from '../../../common/components/expandingList/expandingList';
import CSSTransition from 'react-transition-group/CSSTransition';
import * as HelperFunctions from "../../../common/functions/helperFunctions";
import * as Constants from '../../../common/constants';

interface IProps {
  history: any
  lang: string;
  location: any;
}

interface IState {
  isLoading: boolean;
  validationMessage: string;
  userId: number;
  currentUserPrescription: UserPrescriptionModel;
  userPrescriptions: Array<UserPrescriptionGridModel>
  isVisibleUserPrescriptionAddEditDialog: boolean;
  isVisibleConfirmDialog: boolean;
  currentUserPrescriptionId: number;
  isVisiblePrescriptionMedicinesListDialog: boolean;
  isVisiblePrescriptionDiseaseListDialog: boolean;
  expandedPrescription: Array<UserPrescriptionGridModel>;
  first: number;
  rows: number;
  totalRecords: number;
  activePrescriptionCount: number;
  countVisible: boolean;
}

class UserPrescriptionComponent extends React.Component<IProps, IState> {
  userService = new UserService();
  authService = new AuthService();
  growl: any;

  constructor(props: IProps) {
    super(props);

    this.state = {
      validationMessage: '',
      isLoading: false,
      userId: 0,
      currentUserPrescription: new UserPrescriptionModel(),
      userPrescriptions: new Array<UserPrescriptionGridModel>(0),
      isVisibleUserPrescriptionAddEditDialog: false,
      isVisibleConfirmDialog: false,
      currentUserPrescriptionId: 0,
      isVisiblePrescriptionMedicinesListDialog: false,
      isVisiblePrescriptionDiseaseListDialog: false,
      expandedPrescription: new Array<UserPrescriptionGridModel>(0),
      first: 0,
      rows: 20,
      totalRecords: 0,
      activePrescriptionCount: 0,
      countVisible: true
    };
  }

  componentDidMount() {
    let perscriptionId = HelperFunctions.getURLParameter('perscriptionId');
    if (perscriptionId) {
      this.setState({
        isLoading: true,
        countVisible: false
      });

      if (this.authService.isAuthenticated()) {
        let profile = this.authService.getProfile();
        let id = profile ? profile['id'] : 0;

        this.userService.getUserPrescriptionFromLink(+perscriptionId).then(
          (data: any) => {
            if (data) {
              let prescriptions: Array<UserPrescriptionGridModel> = new Array<UserPrescriptionGridModel>(0);
              prescriptions.push(data);
              this.setState({
                isLoading: false,
                userPrescriptions: [...prescriptions],
                totalRecords: 1,
                activePrescriptionCount: 0,
                userId: id
              });

            }
          })
          .catch(error => {
            this.growl.show({ severity: 'error', summary: error.message });
            this.setState({
              isLoading: false
            });
          });
      }
    }
    else {
      window.addEventListener('scroll', this.onScroll);
      this.getAllUserPrescriptions(true);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll);
  }
  onScroll = () => {
    let scrollY = window.scrollY ? window.scrollY : window.pageYOffset;
    if (window.innerHeight + scrollY >= document.body.offsetHeight - 250 &&
      this.state.totalRecords > this.state.userPrescriptions.length && !this.state.isLoading) {
      this.paginatorClick({ first: this.state.first + this.state.rows }, false);
    }
  };

  paginatorClick = (e, isInit: boolean) => {
    this.setState({ first: e.first }, () => this.getAllUserPrescriptions(isInit));
  }

  componentDidUpdate(prevProps) {
    const locationChanged = this.props.location !== prevProps.location;
    if (locationChanged) {
      let tabName = HelperFunctions.getURLParameter('tabName');
      let perscriptionId = HelperFunctions.getURLParameter('perscriptionId');

      if (tabName && tabName == 'Medicines' && this.props.history.action === "POP") {
        this.handlePrescriptionMedicinesButtonClick(perscriptionId);
      }
      if (tabName && tabName == 'Diseases' && this.props.history.action === "POP") {
        this.handlePrescriptionDiseasesButtonClick(perscriptionId);
      }
      if (!tabName && this.props.history.action === "POP") {
        this.setState({ isVisiblePrescriptionDiseaseListDialog: false, isVisiblePrescriptionMedicinesListDialog: false, first: 0 }, () => this.getAllUserPrescriptions(true));
      }
    }
  }

  getAllUserPrescriptions(isInit: boolean) {
    this.setState({
      isLoading: true
    });

    if (this.authService.isAuthenticated()) {
      let profile = this.authService.getProfile();
      let id = profile ? profile['id'] : 0;

      this.userService.getAllUserPrescriptions(this.state.first, this.state.rows, this.props.lang).then(
        (data: any) => {
          if (data) {
            if (isInit) {
              this.setState({
                isLoading: false,
                userPrescriptions: [...data.userPrescriptions],
                totalRecords: data.totalRecords,
                activePrescriptionCount: data.activePrescriptionCount,
                userId: id
              });
            }
            else {
              this.setState({
                isLoading: false,
                userPrescriptions: [...this.state.userPrescriptions, ...data.userPrescriptions],
                totalRecords: data.totalRecords,
                userId: id
              });
            }
          }
        })
        .catch(error => {
          this.growl.show({ severity: 'error', summary: error.message });
          this.setState({
            isLoading: false
          });
        });
    }
  }

  showEditDialog = (show: boolean) => {
    this.setState({
      isVisibleUserPrescriptionAddEditDialog: show,
      validationMessage: ''
    });
  };

  handleCancelButton = () => {
    this.showEditDialog(false);
  };

  setCurrentUserPrescription(currentUserPrescription: UserPrescriptionModel) {
    this.setState({ currentUserPrescription: { ...currentUserPrescription } });
  }

  handleSaveButton = (currentUserPrescription: UserPrescriptionModel, close: boolean) => {
    this.setState({
      isLoading: true
    });

    if (!currentUserPrescription.userId || currentUserPrescription.userId <= 0) {
      currentUserPrescription.userId = this.state.userId;
    }

    if (!currentUserPrescription.userPrescriptionId) { // Add
      this.userService.addUserPrescription(currentUserPrescription)
        .then(
          (data) => {
            if (close) {
              this.showEditDialog(false);
            }
            this.growl.show({ severity: 'success', summary: Translate('Data Saved Successfully') });
            this.setCurrentUserPrescription(new UserPrescriptionModel());
            this.setState({ first: 0 }, () => this.getAllUserPrescriptions(true));
          },
          error => {
            this.showEditDialog(false);
            this.setCurrentUserPrescription(new UserPrescriptionModel());
            this.growl.show({ severity: 'error', summary: error.message });
            this.setState({
              isLoading: false
            });
          }
        );
    } else { // Edit
      this.userService.updateUserPrescription(currentUserPrescription)
        .then(
          (data) => {
            if (close) {
              this.showEditDialog(false);
            }
            this.growl.show({ severity: 'success', summary: Translate('Data Saved Successfully') });
            this.setCurrentUserPrescription(new UserPrescriptionModel());
            this.setState({ first: 0 }, () => this.getAllUserPrescriptions(true));
          },
          error => {
            this.showEditDialog(false);
            this.setCurrentUserPrescription(new UserPrescriptionModel());
            this.growl.show({ severity: 'error', summary: error.message });
            this.setState({
              isLoading: false
            });
          });
    }
  };

  getUserPrescription = (userPrescriptionId) => {
    this.userService.getUserPrescription(userPrescriptionId, this.props.lang)
      .then(
        (data: UserPrescriptionModel) => {
          this.setCurrentUserPrescription(data);
          this.setState({
            isLoading: false
          });
        },
        error => {
          this.growl.show({ severity: 'error', summary: error.message });
          this.setState({
            isLoading: false
          });
        });
  }

  handleUserPrescriptionDeleteClick = (userPrescriptionId: number) => {
    this.getUserPrescription(userPrescriptionId);
    this.setState({
      isVisibleConfirmDialog: true
    });
  }

  deleteUserPrescription(userPrescriptionId) {
    this.setState({
      isVisibleConfirmDialog: false,
      isLoading: true
    });

    this.userService.deleteUserPrescription(userPrescriptionId)
      .then(
        data => {
          this.setState({ first: 0 }, () => this.getAllUserPrescriptions(true));
          this.growl.show({ severity: 'success', summary: Translate('Deleted Successfully') });
        },
        error => {
          this.growl.show({ severity: 'error', summary: error.message });
          this.setState({
            isLoading: false
          });
        });
  }

  handleUserPrescriptionAddEditClick = (userPrescriptionId) => {

    if (!userPrescriptionId) { // Add			
      this.setCurrentUserPrescription(new UserPrescriptionModel());
      this.showEditDialog(true);
    } else { // Edit
      this.setState({
        isLoading: true
      });
      this.userService.getUserPrescription(userPrescriptionId, this.props.lang)
        .then(
          (data: UserPrescriptionModel) => {
            this.setCurrentUserPrescription(data);
            this.showEditDialog(true);
            this.setState({
              isLoading: false
            });
          },
          error => {
            this.growl.show({ severity: 'error', summary: error.message });
            this.setState({
              isLoading: false
            });
          }
        );
    }
  }

  //************************** Prescription medicines methods ******************************************************/
  handlePrescriptionMedicinesButtonClick = (userPrescriptionId) => {
    if (!userPrescriptionId) {
      this.growl.show({ severity: 'error', summary: "PrescriptionID not valid" });
    } else {
      this.setState({
        currentUserPrescriptionId: userPrescriptionId
      });
      this.props.history.push(`/user/prescriptions?tabName=Medicines&perscriptionId=${userPrescriptionId}`);
      this.showPrescriptionMedicinesListDialog(true);
    }
  }

  handlePrescriptionMedicinesCloseButton = () => {
    this.showPrescriptionMedicinesListDialog(false);
    this.setState({ first: 0 }, () => this.getAllUserPrescriptions(true));
  };

  showPrescriptionMedicinesListDialog = (show: boolean) => {
    this.setState({
      isVisiblePrescriptionMedicinesListDialog: show,
      validationMessage: ''
    });
  };

  //************************** Prescription diseases methods ******************************************************/
  handlePrescriptionDiseasesButtonClick = (userPrescriptionId) => {
    if (!userPrescriptionId) {
      this.growl.show({ severity: 'error', summary: "PrescriptionID not valid" });
    } else {
      this.setState({
        currentUserPrescriptionId: userPrescriptionId
      });
      this.props.history.push(`/user/prescriptions?tabName=Diseases&perscriptionId=${userPrescriptionId}`);
      this.showPrescriptionDiseaseListDialog(true);
    }
  }

  handlePrescriptionDisaeseCloseButton = () => {
    this.showPrescriptionDiseaseListDialog(false);
    this.setState({ first: 0 }, () => this.getAllUserPrescriptions(true));
  };

  showPrescriptionDiseaseListDialog = (show: boolean) => {
    this.setState({
      isVisiblePrescriptionDiseaseListDialog: show,
      validationMessage: ''
    });
  };

  expanedData = (rowData: UserPrescriptionGridModel) => {
    return (
      <div className="item-actions-panel">
        <button
          data-tip={Translate('Medicines')}
          type="button"
          className="item-actions-panel-buttons btn-info"
          style={{ backgroundColor: '#17a2b8', width: 50 }}
          onClick={() => this.handlePrescriptionMedicinesButtonClick(rowData.userPrescriptionId)}>
          <FontAwesomeIcon style={{ verticalAlign: 'text-top' }} icon={faPills}></FontAwesomeIcon></button>
        <button
          data-tip={Translate('Diseases')}
          type="button"
          className="item-actions-panel-buttons btn-info"
          style={{ backgroundColor: '#17a2b8', width: 50 }}
          onClick={() => this.handlePrescriptionDiseasesButtonClick(rowData.userPrescriptionId)}>
          <FontAwesomeIcon style={{ verticalAlign: 'text-top' }} icon={faStethoscope} /></button>
        <button
          type="button"
          className="item-actions-panel-buttons btn-warning"
          style={{ backgroundColor: '#ffba01', width: 50 }}
          onClick={() => this.handleUserPrescriptionAddEditClick(rowData.userPrescriptionId)}
        > <i style={{ verticalAlign: 'text-top' }} className="pi pi-pencil"></i></button>
        <button
          type="button"
          className="item-actions-panel-buttons btn-danger"
          style={{ backgroundColor: '#e91224', width: 50 }}
          onClick={() => this.handleUserPrescriptionDeleteClick(rowData.userPrescriptionId)}
        ><i style={{ verticalAlign: 'text-top' }} className="pi pi-trash"></i></button>
      </div>
    );
  }


  rowExpansionTemplate = (rowData: UserPrescriptionGridModel) => {
    return (
      <CSSTransition in={this.state.expandedPrescription.some(r => r.userPrescriptionId == rowData.userPrescriptionId)}
        timeout={300} classNames="list-slide" mountOnEnter unmountOnExit>
        {this.expanedData(rowData)}
      </CSSTransition>
    );
  }

  expandData = (data: UserPrescriptionGridModel) => {
    if (!this.state.expandedPrescription.some(r => r.userPrescriptionId == data.userPrescriptionId) || this.state.expandedPrescription.length == 0) {
      this.setState({ expandedPrescription: [...this.state.expandedPrescription, data] });
    } else {
      this.setState({ expandedPrescription: this.state.expandedPrescription.filter(r => r.userPrescriptionId != data.userPrescriptionId) });
    }
  }

  keyItem = (m: UserPrescriptionGridModel) => {
    return m.userPrescriptionId + 'perscId';
  }

  itemName = (m: UserPrescriptionGridModel) => {
    return (
      <>
        {m.isActiveNow ? <FontAwesomeIcon icon={faCheckCircle} className="item-info-icon" style={{ color: '#fb512d' }} /> : null}
        {" " + Translate('Course of treatment') + ": "}
        <span style={{ fontWeight: 600 }}>
          {HelperFunctions.fomatDatesStringWithLang(new Date(m.startDate ? m.startDate : ''), this.props.lang) + " - "}
          {HelperFunctions.fomatDatesStringWithLang(new Date(m.endDate ? m.endDate : ''), this.props.lang)}
        </span>
      </>)
  }

  itemDesc = (m: UserPrescriptionGridModel) => {
    return (
      <>
        <div className="item-desc-info">
          <FontAwesomeIcon style={{ width: '24px' }} icon={faUserMd} />
          {m.doctor}
        </div>
        {m.hospital ?
          <div className="item-desc-info">
            <FontAwesomeIcon style={{ width: '24px' }} icon={faHospital} />
            {m.hospital}
          </div>
          : null}
        {m.recommendedFoods ?
          <div className="item-desc-info">
            <FontAwesomeIcon style={{ width: '24px' }} icon={faUtensils} />
            {m.recommendedFoods}
          </div> : null}
        {m.notAllowedFoods ?
          <div className="item-desc-info">
            <FontAwesomeIcon style={{ width: '24px' }} icon={faExclamationTriangle} />
            {m.notAllowedFoods}
          </div> : null}
        {m.recommendedTreatment ?
          <div className="item-desc-info">
            <FontAwesomeIcon style={{ width: '24px' }} icon={faNotesMedical} />
            {m.recommendedTreatment}
          </div> : null}
        <div className="item-desc-info">
          <FontAwesomeIcon style={{ width: '24px' }} icon={faPills} />
          {Translate('Medicines')}
          <div className="badge text-badge">
            {m.userMedicineCount ? m.userMedicineCount : '0'}
          </div>
        </div>
        <div className="item-desc-info">
          <FontAwesomeIcon style={{ width: '24px' }} icon={faStethoscope} />
          {Translate('Diseases')}
          <div className="badge text-badge">
            {m.userDiseaseCount ? m.userDiseaseCount : '0'}
          </div>
        </div>
      </>
    )
  }

  itemActions = (m: UserPrescriptionGridModel) => {
    return (
      <>
        {window.innerWidth >= Constants.device.tablet ? this.expanedData(m) :

          this.state.expandedPrescription.some(r => r.userPrescriptionId == m.userPrescriptionId) ?
            <FontAwesomeIcon icon={faChevronUp} />
            : <FontAwesomeIcon icon={faChevronDown} />
        }
      </>
    )
  }

  public render() {
    const { isLoading, userPrescriptions, totalRecords, activePrescriptionCount, currentUserPrescription,
      currentUserPrescriptionId, expandedPrescription, countVisible } = this.state;

    return (
      <div className="app-content">
        <Growl ref={(el) => this.growl = el} />

        {this.state.isVisiblePrescriptionMedicinesListDialog || this.state.isVisiblePrescriptionDiseaseListDialog ? null :
          <>
            <h1>{Translate('Doctors prescriptions')}</h1>
            <Fab color="primary" aria-label="Add" size="small" onClick={() => this.handleUserPrescriptionAddEditClick(null)} className="floating-action-button">
              <AddIcon />
            </Fab>

            {(!isLoading && userPrescriptions && userPrescriptions.length > 0 && countVisible) ?
              <div className="list-items-count-info">
                <span className='list-items-count-info-number'>{totalRecords}</span> {Translate('total records.')}<br />
                <span className='list-items-count-info-number'>{activePrescriptionCount}</span> {Translate('current doctors prescriptions.')}
                {activePrescriptionCount > 0 ?
                  <span> <FontAwesomeIcon icon={faCheckCircle} className="item-info-icon" style={{ color: '#fb512d' }} /></span>
                  : null}
              </div> : null}

            {/* <UserPrescriptionList
              userPrescriptions={userPrescriptions}
              expandData={this.expandData}
              rowExpansionTemplate={this.rowExpansionTemplate}
              expandedPrescription={expandedPrescription}
              lang={this.props.lang}
            /> */}
            <ExpandingList
              listItems={userPrescriptions}
              keyItem={this.keyItem}
              expandData={this.expandData}
              expandedPanel={this.rowExpansionTemplate}
              itemName={this.itemName}
              itemDesc={this.itemDesc}
              itemActions={this.itemActions}
              isExpandable={window.innerWidth < Constants.device.tablet}
              infoStyle={window.innerWidth < Constants.device.tablet ? {} : { width: 'unset' }}
            />
            {!isLoading && (!userPrescriptions || userPrescriptions.length == 0) ? Translate("No records found") : null}
          </>
        }
        {isLoading ? <Spinner inlineSpinner={true} /> : null}
        {this.state.isVisibleUserPrescriptionAddEditDialog ? (
          <UserPrescriptionAddEditDialog
            currentUserPrescription={currentUserPrescription}
            isVisible={this.state.isVisibleUserPrescriptionAddEditDialog}
            saveClick={this.handleSaveButton}
            cancelClick={this.handleCancelButton}
          />) : null}

        {this.state.isVisiblePrescriptionMedicinesListDialog ? (
          <PrescriptionMedicineListDialog
            userPrescriptionId={currentUserPrescriptionId}
            closeClick={this.handlePrescriptionMedicinesCloseButton}
            lang={this.props.lang}
          />) : null}

        {this.state.isVisiblePrescriptionDiseaseListDialog ? (
          <PrescriptionDiseaseListDialog
            userPrescriptionId={currentUserPrescriptionId}
            isVisible={this.state.isVisiblePrescriptionDiseaseListDialog}
            closeClick={this.handlePrescriptionDisaeseCloseButton}
            lang={this.props.lang}
          />) : null}

        <ConfirmDialog
          headerTitle={Translate("Confirm Dialog")}
          isVisible={this.state.isVisibleConfirmDialog}
          yesClick={() => { this.deleteUserPrescription(currentUserPrescription.userPrescriptionId) }}
          noClick={() => { this.setState({ isVisibleConfirmDialog: false }) }}>
          {Translate("Confirm Message") + " "}
          {(currentUserPrescription && currentUserPrescription.prescription) ? '"' + currentUserPrescription.prescription + '"'
            : Translate("This record")} {Translate('And medicines diseases notifications')}?
        </ConfirmDialog>

      </div>
    )
  }
}

const mapsStateToProps = state => {
  return {
    lang: state.common.lang
  };
}

export default connect(mapsStateToProps)(UserPrescriptionComponent);